import {
  Box,
  Button,
  Divider,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
} from '@material-ui/core';
import React, { useState } from 'react';
import { useQuery } from 'react-query';

import FloatingButton from '../../../../../components/FloatingButton';
import Loader from '../../../../../components/LoaderSplash/Loader.component';
import SharedDialog from '../../../../../components/SharedDialog/SharedDialog.component';
import { useEndorsementsDataContext } from '../../../../../context/endorsements/endorsements.provider';
import { useVehiclesContext } from '../../../../../context/vehicles/vehicles.provider';
import {
  ADJUST_CLAUSE,
  ADJUST_CLAUSE_CONFIG,
  adjustClauseQuery,
} from '../../../../../query/endorsments/adjustClause/adjustClause';
import { adjustClauseQuotation } from '../../../../../services/policy/policy.service';

const SecuredClause = () => {
  const { vehicle: currentVehicle } = useVehiclesContext();
  const { nextStep, updateEndorsementBody } = useEndorsementsDataContext();
  const [percentageValue, setPercentageValue] = useState({
    percent: { value: 0 },
  });
  const [open, setOpen] = useState(false);
  const [hasQuotation, setHasQuotation] = useState(false);
  const [quotation, setQuotation] = useState([]);

  const onSubmit = () => {
    updateEndorsementBody({
      adjustment_clause: { ...quotation, percentage: percentageValue.percent },
    });
    nextStep();
  };

  const { data: adjustClauseData, isLoading } = useQuery(
    [
      ADJUST_CLAUSE,
      { policy_id: currentVehicle.policy.id, vehicle_id: currentVehicle.id },
    ],
    adjustClauseQuery,
    ADJUST_CLAUSE_CONFIG
  );

  const changeValue = (event: any) => {
    setPercentageValue({ percent: event.target.value });
  };

  const handleContinue = () => {
    setOpen(true);
  };

  const generateQuotation = () => {
    setHasQuotation(true);
    getSecuredClauseQuotation();
  };

  const getSecuredClauseQuotation = async () => {
    await adjustClauseQuotation(
      currentVehicle.policy.id,
      adjustClauseData.jobNumber,
      currentVehicle.id,
      percentageValue.percent.value
    ).then((percentageList) => {
      setQuotation(percentageList.data);
    });
  };

  return (
    <>
      {!!Object.keys(currentVehicle).length && (
        <>
          <Box display={isLoading ? 'block' : 'none'}>
            <Loader action={'Cargando información'}></Loader>
          </Box>
          <SharedDialog
            open={open}
            content={
              <Box>
                <Typography
                  variant="h6"
                  style={{ marginTop: '5px', marginBottom: '-15px' }}
                >
                  Este cambio posee un costo adicional.
                </Typography>
              </Box>
            }
            onClose={() => setOpen(false)}
            actions={
              <Grid container>
                <Grid item xs={12} sm={12}>
                  <Box m={2}>
                    <Button
                      variant="contained"
                      color="secondary"
                      fullWidth
                      onClick={onSubmit}
                    >
                      Entendido
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            }
          ></SharedDialog>

          <Grid container justify="center">
            <Grid item xs={11} sm={10} lg={12}>
              <Grid container>
                <Grid item xs={12}>
                  <Box my={3}>
                    <Typography variant="h5" color="primary">
                      Ajustar Cláusula
                    </Typography>
                  </Box>
                </Grid>

                <Grid container justify="center">
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      flexDirection: 'column',
                    }}
                  >
                    <Box my={2} mr={2}>
                      <Typography variant="subtitle1">
                        Clausula de ajuste (%)
                      </Typography>
                      <FormControl
                        fullWidth
                        size="small"
                        variant="outlined"
                        // error={!!errors["vehicle_id"]}
                      >
                        <Select
                          value={percentageValue.percent}
                          onChange={(event) => changeValue(event)}
                          id="percent"
                          name="percent"
                          displayEmpty
                          inputProps={{ 'aria-label': 'Without label' }}
                          style={{ alignItems: 'center' }}
                        >
                          {adjustClauseData?.options.map(
                            (percent: any, index: number) => (
                              <MenuItem key={index} value={percent}>
                                {percent.value * 100 + '%'}
                              </MenuItem>
                            )
                          )}
                        </Select>
                      </FormControl>
                    </Box>
                  </Grid>
                </Grid>

                {hasQuotation && (
                  <Grid item xs={12}>
                    <Grid item xs={12}>
                      <Divider
                        style={{
                          marginTop: '20px',
                          backgroundColor: 'black',
                        }}
                      ></Divider>
                    </Grid>

                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      flexWrap="wrap"
                      marginTop="20px"
                      color="#0033A0"
                    >
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        flexWrap="wrap"
                      >
                        <Typography>COSTO</Typography>
                      </Box>

                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        flexWrap="wrap"
                      >
                        {/* aca falta poner el objeto quotation donde esta el costo */}
                        <Typography>$66</Typography>
                      </Box>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Grid>

            <Grid container justify="center">
              <Grid item xs={12} sm={6}>
                <Box>
                  {hasQuotation ? (
                    <Box>
                      <FloatingButton
                        variant="contained"
                        color="secondary"
                        fullWidth
                        onClick={handleContinue}
                        // disabled={!!Object.keys(errors).length}
                        style={{ marginBottom: '20px' }}
                      >
                        Continuar
                      </FloatingButton>
                    </Box>
                  ) : (
                    <Box>
                      <FloatingButton
                        variant="contained"
                        color="secondary"
                        fullWidth
                        onClick={generateQuotation}
                        // disabled={!!Object.keys(errors).length}
                        style={{ marginBottom: '20px' }}
                      >
                        Cotizar
                      </FloatingButton>
                    </Box>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default SecuredClause;
